import { CommonModule } from '@angular/common';
import { Component, inject, input, model, output } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ResourceButtonGroupComponent } from '../../shared/components/resource-button-group/resource-button-group.component';
import { TargetPeopleArray } from '../models/target-people.model';
import { AccessService } from '../../core/services/access.service';
import { FormsModule } from '@angular/forms';
import { ProviderTypeArray, ProviderType } from '../enums/provider-type.enum';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-target-people-list',
  standalone: true,
  imports: [CommonModule, TableModule, ResourceButtonGroupComponent, FormsModule, DropdownModule],
  templateUrl: './target-people-list.component.html',
  styleUrl: './target-people-list.component.css',
})
export class TargetPeopleListComponent {
  public service = {
    resource: 'target-people',
  }

  public providerTypeArray: ProviderType[] = ProviderTypeArray;


  public save: boolean = false;

  public loading = model<boolean>(false);

  public saveChanges = output<TargetPeopleArray>();

  protected access = inject(AccessService).access;

  public value = input<TargetPeopleArray>([]);

  public length = input<number>(0);

  public resource = input<string>('');

  ngOnInit(): void {
    console.log('Target People List: ', this.value());
    console.log('Target People List: ', this.value().length);
    console.log('provider: ', this.providerTypeArray) 
    // console.log('value ad List: ', this.value().length);
  }

  sumit(value?: any) {
    // console.log('sumit: ', value);

    console.log('sumit loading: ', this.loading());


    console.log('sumit array: ', this.value());

    this.saveChanges.emit(this.value());
  } 
}
